<template>
	<div class="noDataBox" :class="className">
		<img  :src="noDataSrc" alt="">
		<div class="noDataBoxText">{{noDataBoxText}}</div>

	</div>
</template>
<script>
	export default{
		props:{
			className:'',
            noDataBoxText:{
                type: String,
                default: '暂无数据'
            },
		},
		data(){
			return{
				noDataSrc:require('../../../static/img/nodata.png'),
			}
		}
	}
</script>
<style scoped lang="scss">
	.noDataBox{
		width:100%;
		height:100%;
		display:flex;
		flex-direction: column;
		align-items:center;
		justify-content:center;
		img{
			width: 290px;
			height: auto;
		}
		.noDataBoxText{
			margin-top: 10px;
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			color: #AAAAAA;
		}
		&.smallClass{
			img{
				width: 180px;
			}
			.noDataBoxText{
				font-size: 12px;
			}
		}
	}
	@media only screen and (min-width:0px) and (max-width: 768px){
		.noDataBox{
			img{
				width: 200px;
			}
			&.smallClass{
				img{
					width: 150px;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/NoData/noData.vue